/**
 * @generated SignedSource<<5f6264d302ea108c5f51626a3fa3c7ed>>
 * @relayHash ef0a17e995ba217c60488c4f9e0a10d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e4527d85ddf56e2cc9bd1d8d8f06cadb82632bf30ee2efb068041d2b8547334f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e4527d85ddf56e2cc9bd1d8d8f06cadb82632bf30ee2efb068041d2b8547334f",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
